import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import sv from '../locales/sv.json';

export const i18n = createI18n({
  legacy: false,
  locale: localStorage['language'] || 'sv',
  fallbackLocale: 'sv',
  messages: { en, sv },
});
